import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {BaseApiTemplateService, Core2Config} from '../../shared';
import {GenericDocSingleLineContainer, GenericDocLineContainerModel} from '../../../../../../models/aggregates/generic_doc';

@Injectable({
  providedIn: 'root'
})
export class GenericDocSingleLineService extends BaseApiTemplateService<GenericDocLineContainerModel> {

  constructor(http: HttpClient) {
    super();
    this.endpoint_path = `${Core2Config.TENANT_DOMAIN_URL_PREFIX}${Core2Config.ERP_PREFIX}generic-doc/lines`;
    this.httpClient = http;
  }
}
